import { Flex, MenuItem } from "@chakra-ui/react";
import FundFamilyPnlLevelSelectionModal from "features/fund-family/setup/fund/pnl-entities/FundFamilyPnlLevelSelectionModal";
import { useFundFamilyConfigRetrieveSuspense } from "gen/endpoints/fund-family-config/fund-family-config";
import { useTranslation } from "react-i18next";
import {
  ContentBlock,
  ContentBlockActions,
  ContentBlockBody,
  ContentBlockGroup,
  ContentBlockHeader,
  ContentBlockMenu,
  ContentBlockTitle,
} from "shared/components/content/ContentBlock";
import Descriptions from "shared/components/descriptions/Descriptions";
import { useBoolean } from "usehooks-ts";

const FundFamilyPnlLevelSetupCard: React.FC<{
  fundFamilyId: string;
}> = ({ fundFamilyId }) => {
  const { t } = useTranslation(["enums", "common", "waterfall"]);
  const { data: fundFamilyConfig } =
    useFundFamilyConfigRetrieveSuspense(fundFamilyId);
  const getHypotheticalWaterfallEntityDescription = () => {
    if (
      fundFamilyConfig.config.hypothetical_pnl_input_level === "fund_family"
    ) {
      return (
        <Descriptions>
          <Descriptions.Item
            label={t(
              "waterfall:hypotheticalWaterfall.inputLevel.fundFamily.label",
            )}
          >
            {t("waterfall:hypotheticalWaterfall.inputLevel.fundFamily.value")}
          </Descriptions.Item>
        </Descriptions>
      );
    } else {
      return (
        <Descriptions>
          <Descriptions.Item
            label={t(
              "waterfall:hypotheticalWaterfall.inputLevel.customEntity.label",
            )}
          >
            {fundFamilyConfig.current_hypothetical_pnl_entities
              .map((entity) => entity.rich_value)
              .join(", ")}
          </Descriptions.Item>
        </Descriptions>
      );
    }
  };
  const {
    value: isHypoModalOpen,
    setFalse: closeHypoModal,
    toggle,
  } = useBoolean(false);

  return (
    <ContentBlockGroup>
      <ContentBlock>
        <ContentBlockHeader>
          <ContentBlockTitle>
            {t("waterfall:hypotheticalWaterfall.title")}
          </ContentBlockTitle>
          <ContentBlockActions>
            <ContentBlockMenu>
              <MenuItem onClick={toggle}>{t("common:edit")}</MenuItem>
            </ContentBlockMenu>
          </ContentBlockActions>
        </ContentBlockHeader>
        <ContentBlockBody>
          <Flex justify="space-between">
            {getHypotheticalWaterfallEntityDescription()}
            <FundFamilyPnlLevelSelectionModal
              isOpen={isHypoModalOpen}
              onClose={closeHypoModal}
              fundFamilyId={fundFamilyId}
            />
          </Flex>
        </ContentBlockBody>
      </ContentBlock>
    </ContentBlockGroup>
  );
};

export default FundFamilyPnlLevelSetupCard;
